"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomButton = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("styled-components/native");
const S = __importStar(require("./BottomButton.styles"));
const atoms_1 = require("../../../atoms");
const accessibility_1 = require("../../../../../shared/accessibility");
exports.BottomButton = ({ activeIndex, lastIndex, onPressFirstButton, onPressSecondButton, firstButtonTitle, secondButtonTitle, width, scrollX, }) => {
    const isLastIndex = () => {
        return activeIndex === lastIndex;
    };
    const dataLength = lastIndex + 1;
    const theme = native_1.useTheme();
    return (react_1.default.createElement(S.ButtonContainer, null,
        react_1.default.createElement(S.ButtonWrapper, Object.assign({}, accessibility_1.accessibilityProps(`${firstButtonTitle}-button`), { onPress: () => onPressFirstButton(isLastIndex()), style: {
                borderRightWidth: 0.5,
            } }),
            react_1.default.createElement(S.ButtonText, { type: atoms_1.PTextType.VALUE, style: {
                    color: `${isLastIndex() && !(dataLength === 1 && secondButtonTitle)
                        ? theme.bpCore.colors.text
                        : '#111111A3'}`,
                } }, firstButtonTitle)),
        secondButtonTitle && (react_1.default.createElement(S.RightButtonContainer, Object.assign({}, accessibility_1.accessibilityProps(`${secondButtonTitle}-button-container`), { as: react_native_1.Animated.View, style: [
                {
                    flex: react_native_1.Animated.add(scrollX, 0).interpolate({
                        inputRange: [0, width, 2 * width],
                        outputRange: [1, 1, 0],
                    }),
                    opacity: react_native_1.Animated.add(scrollX, 0).interpolate({
                        inputRange: [0, width, 1.5 * width],
                        outputRange: [1, 1, 0],
                    }),
                    width: react_native_1.Animated.add(scrollX, 0).interpolate({
                        inputRange: [0, width, 2 * width],
                        outputRange: [1, 1, 0],
                    }),
                },
            ] }),
            react_1.default.createElement(S.ButtonWrapper, Object.assign({}, accessibility_1.accessibilityProps(`${secondButtonTitle}-button`), { onPress: onPressSecondButton, style: {
                    borderLeftWidth: 0.5,
                } }),
                react_1.default.createElement(S.ButtonText, { type: atoms_1.PTextType.VALUE, style: { color: theme.bpCore.colors.text } }, secondButtonTitle))))));
};
